import { PayloadAction } from '@reduxjs/toolkit';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { STATE__ui } from '../STATE__ui';

export const local_ui_page_tasks_set_new_task_id = (payload: string): PayloadAction<string> => ({
  type: ENUM__redux_action.UI_PAGE_TASKS_SET_NEW_TASK_ID,
  payload,
});

export const init_local_ui_page_tasks_set_new_task_id = (state: STATE__ui, action: PayloadAction<string>) => {
  state.page_tasks_new_task_id = action.payload;
};
